import { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

type PopupProps = {
  isOpen: boolean;
  title: string;
  description: string;
  continueLabel: string;
  cancelLabel: string;
  onContinue: () => void;
  onClose: () => void;
};

const Popup = ({
  isOpen,
  onClose,
  onContinue,
  cancelLabel,
  continueLabel,
  title,
  description,
}: PopupProps) => {
  const cancelRef = useRef(null);

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent padding="20px">
        <AlertDialogCloseButton />
        <AlertDialogHeader>{title}</AlertDialogHeader>

        <AlertDialogBody>{description}</AlertDialogBody>
        <AlertDialogFooter>
          <Button color="black" ref={cancelRef} onClick={onClose}>
            {cancelLabel}
          </Button>
          <Button bgColor="primaryColor" ml={3} onClick={onContinue}>
            {continueLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default Popup;
